
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-IN').format(value);
};
